export default function menu() {
    const nav_dropdown = document.querySelectorAll('.nav_item.dropdown');
    const submenu_nav_btn = document.querySelectorAll('.nav_item .submenu_nav_btn');
    const menu_open = document.querySelector('.menu_open');
    const menu_close = document.querySelector('.menu_close');
    const menu = document.querySelector('.top_nav .menu');

    addToDOMScrollbarWidth();
    document.addEventListener('resize', addToDOMScrollbarWidth);

    nav_dropdown.forEach(el => {
        el.querySelector('.dropdown_btn').addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (!el.classList.contains('active')) {
                el.querySelectorAll('.submenu_nav_btn').forEach(btn => btn.classList.remove('active'));
                el.querySelectorAll('.submenu_item').forEach(item => item.classList.remove('active'));
                const isDetailedMenu = el.querySelector('.submenu_detailed');

                if (isDetailedMenu) {
                    const firstBtn = el.querySelector('.submenu_nav_btn');
                    const firstItem = el.querySelector('.submenu_item');
                    if (firstBtn) firstBtn.classList.add('active');
                    if (firstItem) firstItem.classList.add('active');
                }

                nav_dropdownRemoveActive();
                el.classList.add('active');
                el.querySelector('.dropdown_body').classList.add('open');

                if (window.matchMedia('(min-width: 961px)').matches) {
                    document.body.classList.add('menu_open');
                }
            } else {
                el.classList.remove('active');
                el.querySelector('.dropdown_body').classList.remove('open');

                if (window.matchMedia('(min-width: 961px)').matches) {
                    document.body.classList.remove('menu_open');
                }
            }
        });

        el.querySelector('.go_back_btn').addEventListener('click', () => {
            el.classList.remove('active');
            el.querySelector('.dropdown_body').classList.remove('open');
        });
    });

    function nav_dropdownRemoveActive() {
        nav_dropdown.forEach(element => {
            element.classList.remove('active');
            const dropdownBody = element.querySelector('.dropdown_body');
            if (dropdownBody) {
                dropdownBody.classList.remove('open');
            }
        });
    }

    submenu_nav_btn.forEach(el => {
        el.addEventListener('mouseover', (e) => {
            const parentDropdown = e.currentTarget.closest('.nav_item.dropdown');
            if (parentDropdown) {
                parentDropdown.querySelectorAll('.submenu_item').forEach(item => item.classList.remove('active'));
                parentDropdown.querySelectorAll('.submenu_nav_btn').forEach(btn => btn.classList.remove('active'));
            }

            e.currentTarget.classList.add('active');
            const id = e.currentTarget.dataset.tabId;
            const submenu_item = document.getElementById(id);
            if (submenu_item) {
                submenu_item.classList.add('active');
            }
        });

        el.addEventListener('click', (e) => {
            const link = e.currentTarget.querySelector('a');
            if (link && link.href) {
                window.location.href = link.href;
            }
        });
    });

    function addToDOMScrollbarWidth() {
        const e = window.innerWidth - document.body.clientWidth;
        document.body.style.setProperty("--scrollbarWidth", `${e}px`);
    }

    menu_open.addEventListener('click', openMenu);
    menu_close.addEventListener('click', closeMenu);

    function openMenu(e) {
        menu.classList.add('open');
        document.body.classList.add('menu_open');
    }

    function closeMenu() {
        menu.classList.remove('open');
        document.body.classList.remove('menu_open');
    }

    document.addEventListener('click', (e) => {
        if (e.target.classList.contains('menu_open')) {
            nav_dropdownRemoveActive();
            closeMenu();
            document.body.classList.remove('menu_open');
        }

        if (!e.target.closest('.nav_item.dropdown')) {
            nav_dropdownRemoveActive();
            if (window.matchMedia('(min-width: 961px)').matches) {
                document.body.classList.remove('menu_open');
            }
        }
    });
}